<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents" *ngIf="details?.aptid">
    <div align="center">
      <h2 class="mt-2 mb-4 text-color font-size-25 font-weight-500">
        APPOINTMENT INFORMATION
      </h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="bg-primary text-white p-3">
          <h5 class="mt-2 ml-3">APPOINTMENT ID: {{ details?.aptid }}</h5>
        </div>
        <br />
        <div class="bg-primary text-white p-1">
          <h5 class="mt-2 ml-4">YOUR CONSULTING DOCTOR</h5>
        </div>
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-3">
                <!-- <div class="card m-b-30 border-0"> -->
                <!-- <img [src]="physician?.ppurl" class="rounded-circle w-100 h-100" /> -->
                <img [src]="physician?.ppurl" class="image" />
                <!-- </div> -->
              </div>
              <div class="col-md-6 detail-tbl">
                <h3 class="text-color font-size-20 text-capitalize">
                  {{ physician?.title ? physician?.title : defaultDr }}
                  {{ physician?.first_name }} {{ physician?.last_name }}
                  {{ physician?.qualification }}
                </h3>
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Speciality
                      </td>
                      <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician_model?.speciality }}
                      </td>
                    </tr>

                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        University
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician_model?.university }}
                      </td>
                    </tr>
                    <!--<tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">Education</td>
                      <td class="text-change  font-size-16 font-weight-500 text-capitalize border-0">
                        {{physician_model?.education}}
                      </td>
                    </tr> -->
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Location
                      </td>
                      <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician?.city }}{{ physician_model?.location }}
                      </td>
                    </tr>
                    <tr *ngIf="
                        physician &&
                        physician.physician_qualification &&
                        physician.physician_qualification.length > 0
                      ">
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Registration No.
                      </td>
                      <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician?.physician_qualification[0].r_no }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-primary text-white p-1">
          <h5 class="mt-2 ml-4">APPOINTMENT DETAILS</h5>
        </div>
        <br />
        <div class="row">
          <div class="col-md-6">
            <div class="card m-b-30">
              <div class="card-body">
                <div class="row pt-2">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Name</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-weight-500 font-size-16">
                        {{ details?.patient_details?.first_name }}
                        {{ details?.patient_details?.last_name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Date of birth</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-weight-500 font-size-16">
                        {{ details?.patient_details?.dob | date: dateFormat }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Gender</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-change font-weight-500 text-break font-size-16 text-capitalize">
                        {{ details?.patient_details?.gender }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Contact Number</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-weight-500 font-size-16">
                        {{ details?.patient_details?.contact_no }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Email Address</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-change font-weight-500 text-break font-size-16 text-break">
                        {{ details?.patient_details?.email_id }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card m-b-30">
              <div class="card-body mb-3">
                <div class="row pt-2">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Consultation Type</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-weight-500 font-size-16">
                        {{ details?.apttype }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Appointment Date And
                        Time</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-size-16 font-weight-500 text-break">
                        {{ details?.apdate | date: dateFormat }} -
                        {{ details?.aptime }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Appointment Status</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-success text-break font-size-16 font-weight-500 text-capitalize">
                        {{ details?.schedule_stat }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text font-size-16 font-weight-400">Doctor</label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-capitalize text-change font-size-16 font-weight-500">
                        {{ details?.physician_details?.first_name }}
                        {{ details?.physician_details?.last_name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex pl-0">
                    <div class="col-md-6">
                      <label class="font-color label-text"></label>
                    </div>
                    <div class="col-md-6">
                      <p class="text-change font-size-16 font-weight-500 text-break"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card m-b-30" [hidden]="inpersonvideo">
          <div class="card-body">
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-3">
                  <label class="font-color label-text font-size-16 font-weight-400">Drug Allergy</label>
                </div>
                <div class="col-md-9 pl-2">
                  <p class="text-capitalize text-change font-size-16 font-weight-500">
                    {{ details?.drug_allergy ? "Yes" : "No" }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 d-flex pl-0">
                <div class="col-md-3">
                  <label class="font-color label-text font-size-16 font-weight-400">Concern</label>
                </div>
                <div class="col-md-9 pl-2">
                  <p class="text-capitalize text-change font-size-16 font-weight-500">
                    {{ details?.remarks }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- New changes-->
        <div *ngIf="details?.schedule_stat == 'SCHEDULED'">
          <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">UPLOAD DOCUMENTS<span class="font-italic font-size-14 ml-2">(Upto 10 documents can be
                uploaded,File size not to exceed 2 MB)</span></h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body">
              <!--new-->
              <form [formGroup]="forms['documentsForm']">
                <div>
                  <div class="form-group" formArrayName="documents" *ngFor="
                      let item of forms['documentsForm'].get('documents')[
                        'controls'
                      ];
                      let i = index
                    ">
                    <div class="row d-flex" [formGroupName]="i">
                      <div class="col-md-4">
                        <input type="text" class="form-control text-dark" formControlName="description"
                          name="description" form placeholder="Enter description"
                          [readonly]="documents?.at(i).get('readOnly').value"
                          [ngClass]="{ 'is-invalid':formValidation(i, 'description', 'documents') }" />
                        <div *ngIf="
                            documents?.at(i).get('description') &&
                            documents
                              ?.at(i)
                              .get('description')
                              .hasError('required')
                          " class="invalid-feedback">
                          This is required
                        </div>
                      </div>
                      <div class="col-md-4" *ngIf="!documents?.at(i).get('readOnly').value">
                        <input #inputFile class="form-control text-dark" type="file"
                          accept="application/pdf, .png,.jpg,.jpeg" (change)="selectFile($event, i)"
                          placeholder="Select file" />
                        <div class="font-color label-text font-size-10 font-weight-400">
                          eg. pdf, jpeg, png
                        </div>
                        <div *ngIf="
                            documents?.at(i).get('name') &&
                            documents?.at(i).get('name').hasError('required')
                          " class="invalid-feedback">
                          This is required
                        </div>
                      </div>

                      <div class="col-md-4" *ngIf="documents?.at(i).get('readOnly').value">
                        <input class="form-control text-dark" type="text" readonly formControlName="name" name="name" />
                      </div>
                      <div class="col-md-2" *ngIf="!documents?.at(i).get('readOnly').value">
                        <button type="button" class="form-control btn btn-primary btn-doctor"
                          [disabled]="!documents?.at(i).get('name').value" (click)="previewDocument(i)">
                          Preview
                        </button>
                      </div>

                      <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                        *ngIf="!documents?.at(i).get('readOnly').value">
                        <button *ngIf="i >= 0" type="button" class="btn btn-outline-primary removeitem"
                          style="padding: 12px 16px" (click)="removingCurrentDocument(i)">
                          <i class="fa fa-close"></i>
                        </button>
                        <!-- <button
                          *ngIf="i == 0 && documents?.at(i).get('name').value"
                          type="button"
                          class="btn btn-outline-primary removeitem"
                          style="padding: 12px 16px"
                          (click)="resetForm(i)"
                        >
                          <i class="fa fa-close"></i>
                        </button> -->
                      </div>
                      <div class="col-4 col-sm-2 col-md-1 m-m text-right"
                        *ngIf="!documents?.at(i).get('readOnly').value">
                        <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px"
                          (click)="addingDocument(i)">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <button *ngIf="!disableSubmit" type="button" class="btn btn-primary btn-doctor pull-right"
                    [disabled]="forms['documentsForm'].invalid" (click)="saveDocuments()">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--  New changes end-->

        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6" [hidden]="inpersonvideo">
                <p class="font-size-16 font-weight-500">
                  Do you want to Reschedule appointment
                </p>
                <form [formGroup]="rescheduleForm">
                  <div class="row">
                    <div class="col-10">
                      <div class="d-flex">
                        <input class="form-control" placeholder="" name="appointmentDate" formControlName="apdate"
                          ngbDatepicker #appointment="ngbDatepicker" data-date-inline-picker="false"
                          id="appointmentDate" [minDate]="aptinterval" [markDisabled]="isDateDisabled"
                          (dateSelect)="getTimeSlots()" />
                        <div>
                          <button class="btn btn-outline-secondary button-height calendar rounded-0"
                            (click)="appointment.toggle()" type="button" id="AppointmentButton">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                      </div>
                      <div *ngIf="
                          rescheduleForm.get('apdate').hasError('required')
                        " class="invalid-feedback">
                        Appointment Date is required
                      </div>
                      <div *ngIf="
                          !rescheduleForm.get('apdate').hasError('required') &&
                          rescheduleForm.get('apdate').hasError('ngbDate')
                        " class="invalid-feedback">
                        Appointment Date is invalid
                      </div>
                    </div>
                  </div>

                  <div class="row pt-3" *ngIf="timeSlots?.length">
                    <div class="col-lg-12 mb-3">
                      Select from the following available Timeslots<span class="text-danger">*</span>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-check form-check-inline" *ngFor="let t of timeSlots; let i = index">
                        <label class="form-check-label" for="{{ i }}">
                          <span class="btn btn-primary" [ngClass]="{ 'btn-success': isSelectedItem(i) }">{{ t.start_time
                            }}</span>
                        </label>
                        <input type="radio" name="appointmentTime" class="form-check-input invisible"
                          value="{{ t.start_time }}" id="{{ i }}" (change)="TimeSlotSelected(i)" [(ngModel)]="aptime"
                          [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div *ngIf="
                          rescheduleForm.get('aptime').hasError('required')
                        " class="invalid-feedback">
                        Appointment Time is required
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-6">
                <p class="font-size-16 font-weight-500">
                  Link to attend Consultation
                </p>
                <div class="row">
                  <div class="col-12">
                    <a href="{{ details?.conference_link }}" class="text-color mt-3 font-weight-500" target="_blank">{{
                      details?.conference_link }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-block d-lg-flex">
          <button type="button" class="btn btn-danger w-100 mt-2 mr-2 pl-5 pr-5" [hidden]="inpersonvideo"
            (click)="cancelAppointment()">
            CANCEL MY APPOINTMENT
          </button>
          <button type="button" class="btn btn-primary mt-2 w-100 pl-0 pl-md-5 pr-0 pr-md-5"
            [disabled]="rescheduleForm.invalid" [hidden]="inpersonvideo" (click)="rescheduleAppointment()">
            REQUEST RESCHEDULE APPOINTMENT
          </button>
        </div>
        <p class="text-center mt-3 text-danger font-weight-500 font-size-20" *ngIf="inpersonvideo">
          This appointment was sheduled by your clinic, please contact them for cancel / reschedule
        </p>
        <p class="text-center mt-3 text-danger font-weight-500 font-size-20" *ngIf="!inpersonvideo">
          NOTE: You cannot Cancel/ Reschedule appointment just 24 hours prior to
          actual appointment
        </p>

        <p class="text-center mt-3 font-weight-500 font-size-20">
          You will be receiving the appointment details message within a few
          minutes of booking, please check your Spam / Junk folder just in case
          the email got delivered there instead of your Inbox. If so, select the
          message and click Not Spam, which will allow future messages to get
          through.
        </p>
      </div>
    </div>
  </div>

  <div class="container-fluid header-fix position-relative display-contents"
    *ngIf="!details?.aptid && isLoading == false">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 mt-2 text-center">
                <h5 class="text-danger">NO APPOINTMENT FOUND</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>

<!--new changes -->
<ng-template #PDFModal>
  <div>
    <div class="modal-header">
      <button type="button" class="close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div>
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block"></pdf-viewer>
    </div>
  </div>
</ng-template>